// extracted by mini-css-extract-plugin
export default {"table-header-text":"table-header-text_e2RH1O4j","table-header__sub-header-text":"table-header__sub-header-text_zPSpyy77","quantity-header-space":"quantity-header-space_Ji6d_cPC"};